export const NON_PADDING_DEFAULT_RATIO = 1.0

export const EXPORT_TYPE: { name: 'png' | 'svg', label: string }[] = [
  {
    name: 'png',
    label: 'png形式で書き出す',
  },
  {
    name: 'svg',
    label: 'svg形式で書き出す（再編集可能なベクタ形式）',
  }
]

export const STYLE_MODAL = {
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 9998,
  overlay: {
    zIndex: 9998,
    backgroundColor: 'rgba(0,0,0,0.65)',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    padding: '0',
    width: '640px',
    maxWidth: '90vw',
    maxHeight: '90vh',
    transform: 'translate(-50%, -50%)',
  },
}
